import { render, staticRenderFns } from "./VuetablePaginationDropdown.vue?vue&type=template&id=4925f3e2&"
import script from "./VuetablePaginationDropdown.vue?vue&type=script&lang=js&"
export * from "./VuetablePaginationDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports